const routes: Array<HubRouteConfig> = [
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('../views/ViewDashboard.vue'),
    meta: {
      title: 'home',
      breadcrumb: [{
        text: 'home',
      }],
      requiresAuth: true,
    },
  },
  {
    path: '/event/:hash',
    name: 'Event',
    props: true,
    component: () => import('../views/ViewEvent.vue'),
    meta: {
      title: 'event',
      breadcrumb: [{
        text: 'event',
        href: '/events',
      }],
      requiresAuth: true,
      backButton: true,
    },
  },
  {
    path: '/events',
    name: 'Events',
    component: () => import('../views/ViewEvents.vue'),
    meta: {
      title: 'events',
      breadcrumb: [{
        text: 'all_events',
      }],
      requiresAuth: true,
    },
  },
  {
    path: '/uploads',
    name: 'Uploads',
    component: () => import('../views/ViewUploads.vue'),
    meta: {
      title: 'uploads',
      breadcrumb: [{
        text: 'all_uploads',
      }],
      requiresAuth: true,
    },
  },
  {
    path: '/',
    redirect: { name: 'Uploads' },
  },
  {
    path: '/video/:id',
    name: 'Video',
    props: true,
    component: () => import('../views/VideoView.vue'),
    meta: {
      title: 'Video',
      breadcrumb: [{
        text: 'Video',
      }],
      requiresAuth: true,
      backButton: true,
    },
  },
  {
    path: '/transcription/:id/:language',
    name: 'Transcription and Translation',
    props: true,
    component: () => import('../views/ViewTranscription.vue'),
    meta: {
      title: 'Transcription and Translation',
      breadcrumb: [{
        text: 'Transcription and Translation',
      }],
      requiresAuth: true,
      backButton: true,
    },
  },
  {
    path: '/gallery/:id',
    name: 'Gallery',
    props: true,
    component: () => import('../components/FolderView.vue'),
    meta: {
      title: 'gallery',
      breadcrumb: [{
        text: 'gallery',
        href: '/galleries',
      }],
      requiresAuth: true,
      backButton: true,
    },
  },
  {
    path: '/galleries',
    name: 'Galleries',
    component: () => import('../views/ViewGalleries.vue'),
    meta: {
      title: 'gallery',
      breadcrumb: [{
        text: 'all_galleries',
      }],
      requiresAuth: true,
    },
  },
  {
    path: '/logs',
    name: 'Logs',
    component: () => import('../views/LogsView.vue'),
    meta: {
      title: 'Logs',
      breadcrumb: [{
        text: 'all_logs',
      }],
      requiresAuth: true,
    },
  },
  {
    path: '/player/:hash',
    name: 'PlayerEvent',
    props: true,
    component: () => import('../views/ViewPlayer/index.vue'),
    meta: {
      title: 'player',
      breadcrumb: [{
        text: 'Player',
        href: '/events',
      }],
      requiresAuth: true,
      backButton: true,
    },
  },
  {
    path: '/live-social/:hash',
    name: 'LiveSocial',
    component: () => import('../views/ViewLiveSocial.vue'),
    props: true,
    meta: {
      title: 'Live Social',
      breadcrumb: [{
        text: 'Live Social',
        href: '/events',
      }],
      requiresAuth: true,
      backButton: true,
    },
  },
  {
    path: '/payments/stripe/success',
    name: 'StripeSuccess',
    component: () => import('../views/ViewPayments/Stripe/ViewSuccess.vue'),
    props: true,
    meta: {
      title: 'Stripe Success',
      breadcrumb: [{
        text: 'Stripe Success',
        href: '/events',
      }],
      requiresAuth: true,
      backButton: true,
    },
  },
  {
    path: '/payments/stripe/cancel',
    name: 'StripeCancel',
    component: () => import('../views/ViewPayments/Stripe/ViewCancel.vue'),
    props: true,
    meta: {
      title: 'Stripe Cancel',
      breadcrumb: [{
        text: 'Stripe Cancel',
        href: '/events',
      }],
      requiresAuth: true,
      backButton: true,
    },
  },
  {
    path: '/callback/facebook',
    component: () => import('../views/callback/ViewCallbackFacebook.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/callback/youtube',
    component: () => import('../views/callback/ViewCallbackYoutube.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/facebook-settings/:hash',
    name: 'FacebookSettings',
    component: () => import('../views/ViewFacebook.vue'),
    props: true,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/statistics/:hash',
    name: 'Statistics',
    component: () => import('../views/ViewStatistics.vue'),
    props: true,
    meta: {
      title: 'statistics',
      breadcrumb: [{
        text: 'statistics',
        href: '/events',
      }],
      requiresAuth: true,
      backButton: true,
    },
  },
  {
    path: '/login/hub/:page/:token',
    name: 'LoginFromHub',
    component: () => import('../views/ViewLoginHub.vue'),
    props: true,
    meta: {
      title: 'loginFromHub1',
    },
  },
  {
    path: '/invoice/:prospectId/:invoiceHash',
    name: 'ViewInvoice',
    component: () => import('../views/ViewInvoice.vue'),
    props: true,
  },
  {
    path: '/channels',
    name: 'Channels',
    component: () => import('../views/ViewHotsites.vue'),
    meta: {
      title: 'Channels',
      breadcrumb: [{
        text: 'all_channels',
      }],
      requiresAuth: true,
    },
  },
  {
    path: '/Customize/:categoryId/:hotsiteId',
    name: 'Customize',
    props: true,
    component: () => import('../views/ViewCustomize.vue'),
    meta: { backButton: true },
  },
  {
    path: '/WebTV/:categoryId/:hotsiteId',
    name: 'WebTV',
    props: true,
    component: () => import('../views/ViewWebTV.vue'),
    meta: { backButton: true },
  },
  {
    path: '/*',
    name: 'Error404',
    redirect: {
      name: 'Error',
      params: { error: '404' },
    },
  },
  {
    path: '/:error',
    name: 'Error',
    component: () => import('../views/ViewError.vue'),
    props: true,
  },

];

export default routes;
